import { GENERATION_TOOL, isToolSupportCopyScoringModel } from 'src/data/generationTool';
import { ASSET_TYPE } from 'src/data/asset';

export const COPY_SCORING_MODEL_TEMPLATE = {
  facebookPrimaryText: ASSET_TYPE.facebookPrimaryText,
  // DS won’t be ready to support FB and Google Headlines for the upcoming release.
  // https://keywee.slack.com/archives/CFKBG7YM6/p1662290968918329
  facebookHeadline: ASSET_TYPE.facebookHeadline,
  googleDescription: ASSET_TYPE.googleDescription,
  googleHeadline: ASSET_TYPE.googleHeadline,
  linkedinSingleImageHeadline: ASSET_TYPE.linkedinSingleImageHeadline,
  linkedinSingleImageIntro: ASSET_TYPE.linkedinSingleImageIntro,
};

export const COPY_SCORING_MODEL_TEMPLATE_PROPS = {
  [COPY_SCORING_MODEL_TEMPLATE.facebookPrimaryText]: {
    title: 'Facebook Ads',
    description: 'Primary Texts',
    generationTool: GENERATION_TOOL.facebookPrimaryTextProduct,
  },
  [COPY_SCORING_MODEL_TEMPLATE.facebookHeadline]: {
    title: 'Facebook Ads',
    description: 'Headlines',
    generationTool: GENERATION_TOOL.facebookHeadlineProduct,
  },
  [COPY_SCORING_MODEL_TEMPLATE.googleDescription]: {
    title: 'Google Search Ads',
    description: 'Descriptions',
    generationTool: GENERATION_TOOL.googleDescriptionProduct,
  },
  [COPY_SCORING_MODEL_TEMPLATE.googleHeadline]: {
    title: 'Google Search Ads',
    description: 'Headlines',
    generationTool: GENERATION_TOOL.googleHeadlineProduct,
  },
  [COPY_SCORING_MODEL_TEMPLATE.linkedinSingleImageHeadline]: {
    title: 'LinkedIn Single Image',
    description: 'Headlines',
    generationTool: GENERATION_TOOL.linkedinHeadlineSingleImage,
  },
  [COPY_SCORING_MODEL_TEMPLATE.linkedinSingleImageIntro]: {
    title: 'LinkedIn Single Image',
    description: 'Copy',
    generationTool: GENERATION_TOOL.linkedinIntroSingleImage,
  },
};

export const isCopyScoringModelEnabledForGenerationTool = (generationTool) =>
  isToolSupportCopyScoringModel(generationTool);

export const COPY_SCORING_MODEL_STATUS = {
  created: 'created',
  validation_in_progress: 'validation_in_progress',
  validation_done: 'validation_done',
  training_in_progress: 'training_in_progress',
  error: 'error',
  archived: 'archived',
  active: 'active',
};

const PROCESSING_ERROR_TYPE = {
  notEnoughDatasetError: 'not_enough_dataset_error',
  notEnoughRelevantDataError: 'not_enough_relevant_data_error',
};

const PROCESSING_ERROR_TYPE_PROPS = {
  [PROCESSING_ERROR_TYPE.notEnoughDatasetError]: {
    message:
      'Not Enough Data: Please select additional data sets to create a reliable custom scoring model.',
  },
  [PROCESSING_ERROR_TYPE.notEnoughRelevantDataError]: {
    message:
      'We were unable to create a reliable custom scoring model from the data you selected. Please choose data from more campaigns for a more reliable model.',
  },
};

export const getProcessingErrorTypeMessage = (type) =>
  PROCESSING_ERROR_TYPE_PROPS[type]?.message ||
  'We were unable to create a custom scoring model. Please try again later.';
